// Props Proxy HOC that adds Esc key handling to unfocus the editor
import React from 'react'
import { getDisplayName } from 'util/hoc'
import ListenToKeyboard from 'components/ListenToKeyboard'

function withFocusing(WrappedEditor) {
  class WithFocusing extends React.Component {
    state = { focused: false }

    componentDidMount() {
      document.addEventListener('click', this.handleClick, true)
    }

    componentWillUnmount() {
      document.removeEventListener('click', this.handleClick, true)
    }

    handleEsc = () => {
      const { focused } = this.state
      if (focused) this.handleBlur()
    }

    handleFocus = () => {
      this.trackFocus(true, this.props.onFocus)
    }

    handleBlur = () => {
      this.trackFocus(false, this.props.onBlur)
    }

    handleClick = e => {
      const { focused } = this.state
      const isClickedInside = e && this.node && this.node.contains(e.target)

      if (isClickedInside && !focused) this.handleFocus()
      if (!isClickedInside && focused) this.handleBlur()
    }

    trackFocus = (focused, handlerFn) => {
      this.setState({ focused })
      if (!handlerFn) return false
      if (typeof handlerFn !== 'function') return false
      return handlerFn()
    }

    saveRef = node => (this.node = node)

    render() {
      const { focused } = this.state
      return (
        <div id="wmf" ref={this.saveRef}>
          <ListenToKeyboard onEscape={this.handleEsc} />
          <WrappedEditor
            {...this.props}
            focused={focused}
            forwardRef={this.saveRef}
            onEditorFocus={this.handleFocus}
            onEditorBlur={this.handleBlur}
          />
        </div>
      )
    }
  }

  WithFocusing.displayName = `WithFocusing(${getDisplayName(WrappedEditor)})`

  return WithFocusing
}

export default withFocusing
